import styled from 'styled-components';
import {media} from '@styles';

enum Align {
  center = 'center',
  left = 'left',
  right = 'right',
}

const SubHeadline = styled.h4`
  font-size: 1.25rem;
  line-height: 1.6875rem;
  text-align: ${props => Align[props.align] || Align.left};

  ${media.tablet`font-size: 1rem; line-height: 1.375rem;`}
`;

export default SubHeadline;
